import { LearningPortfolioParams } from './learning-portfolio.value';

// Notes are cached per params combination, so two equivalent requests must produce the same key:
// array order and search casing/whitespace are irrelevant to the API, and so are they here.
export function createLearningPortfolioParamsKey(params: LearningPortfolioParams): string {
    return JSON.stringify({
        type: [...(params.type ?? [])].sort(),
        categoryIds: [...(params.categoryIds ?? [])].sort(),
        courseId: params.courseId ?? '',
        moduleId: params.moduleId ?? '',
        lessonId: params.lessonId ?? '',
        from: params.from ?? null,
        to: params.to ?? null,
        search: params.search?.trim().toLowerCase() ?? '',
        source: params.source ?? '',
        limit: params.limit ?? null,
        offset: params.offset ?? 0,
    });
}
